import { useNavigate } from "react-router-dom";

// const Card = ({ post, designation }) => {
//   return (
//     <div className="rounded-[1rem] min-w-[300px] max-w-fit p-4 h-fit bg-gradient-to-b from-white/60 to-white/80 backdrop-blur-sm hover:shadow-lg hover:shadow-[#307bc4]/50 transition-all duration-300 ease-in-out">
//       <div>
//         <h4 className="text-xl mb-2 text-[#307bc4]">{post}</h4>
//         <p>{designation}</p>
//       </div>
//       <div className="flex justify-between items-center">
//         <a
//           href="https://career.nhwm.in/"
//           rel="noreferrer noopener"
//           target="_blank"
//           className="text-lg font-medium"
//         >
//           Learn More
//         </a>{" "}
//         <HowToApplyDialog>
//           <p className="text-lg font-medium mb-0">How to Apply</p>
//         </HowToApplyDialog>
//       </div>
//     </div>
//   );
// };

export default function HeroStyle4({
  title,
  subTitle,
  bgUrl,
  imgUrl,
  imgUrl2,
  imgUrl3,
}) {

  const navigate = useNavigate();

  return (
    <section
      className="cs_hero cs_style_4 cs_bg_filed"
      style={{ backgroundImage: `url(${bgUrl})` }}
    >
      <div className="container">
        <div className="md:flex md:pb-8">
          <div className="md:max-w-[60%]">
            <div className="relative">
              <div className="cs_hero_text">
                <h1 className="cs_hero_title cs_white_color cs_fs_84 p-2">
                  {title}
                </h1>
                <div className="backdrop-blur-md bg-white/10 rounded-xl p-2">
                  <p className="cs_hero_subtitle cs_white_color cs_fs_20">
                    {subTitle}
                  </p>
                </div>
              </div>
              <div className="cs_banner_img  md:hidden absolute top-0 left-0">
                <img
                  src="/images/career/career_job.png"
                  alt="Banner"
                  className="rounded-bl-none rounded-br-none rounded-tl-[15px] rounded-tr-[15px]"
                />
              </div>
            </div>

            <div className="p-4 rounded-xl backdrop-blur-sm bg-white/20 md:max-w-[90%] mx-auto mt-12">
              <h4 className="text-center md:text-2xl">Available Jobs</h4>
              <div className="flex flex-col md:flex-row justify-evenly items-center gap-4">
                <div className="rounded-[1rem] min-w-[300px] max-w-fit p-4 h-fit bg-gradient-to-b from-white/60 to-white/80 backdrop-blur-lg transition-all duration-300 ease-in-out">
                  <div className="text-center">
                    <h4 className="font-mono mb-2 text-[#307bc4] flex flex-col gap-2">
                      <span>DWO</span>
                      <span className="text-base">(Applications Open)</span>
                    </h4>
                  </div>
                  <div className="flex justify-between items-center">
                    <button
                      onClick={() => navigate("/career/interview")}
                      className="ml-2 mx-auto bg-[#42679e] py-2 px-4 rounded-xl hover:scale-105 transition duration-300 text-white font-mono text-md mb-0 hover:shadow-md hover:shadow-gray-400"
                    >
                      Register For Interview
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="cs_banner_img max-w-[665px] hidden md:block">
            <img
              src="/images/career/career_job.png"
              alt="Banner"
              style={{ borderRadius: "15px" }}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
